import React from "react";

const InvalidFeedback = ({error}) => {
    if (!error) {
        return '';
    }
    return (
        <div className="invalid-feedback d-block">
            {error}
        </div>
    )
}


export default InvalidFeedback;
